import { Component, OnInit } from '@angular/core';
import {AuthServiceService} from '../../../shareModule/services/auth-service.service';
import {LocalServiceService} from '../../../shareModule/services/local-service.service';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-redeem-voucher',
  templateUrl: './redeem-voucher.component.html',
  styleUrls: ['./redeem-voucher.component.scss']
})
export class RedeemVoucherComponent implements OnInit {

  promotional = [];
  imageUrl = environment.ImageUrl;

  constructor(private auth:AuthServiceService,private local:LocalServiceService) { }

  ngOnInit(): void {
    this.getVoucher();
  }


  getVoucher(){
    this.auth.get_available_promotions().subscribe((response:any)=>{
      this.promotional = response.body;
      // console.log(response);
    },(e)=>{
      if(e.error == 401){
        this.local.logout();
      }
    })

  }


  onImg(event){ event.target.src = '../../../assets/images/gift_img.png'}

}
